import tw from 'twin.macro';
import {
  styled
} from 'styled-components';

export const CalendarHeader = styled.div`
  ${tw`flex justify-between items-center gap-6 border-0 bg-white`}
`;

export const CalendarHeaderInfo = styled.div`
  ${tw`flex flex-col items-center justify-center gap-1`}
`;

export const HeaderMonth = styled.p`
  ${tw`text-17-26 font-bold text-black`}
`;

export const HeaderYear = styled.p`
  ${tw`text-xs leading-5 font-medium text-grey-dark-40`}
`;
